import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  display: flex;
  align-items: stretch;
  min-height: ${p => p.minHeight || "auto"};
`;

const Wrapper = ({
  children,
  minHeight
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    minHeight: minHeight
  }, children);
};

export default Wrapper;